// Vendor Libs
import React, {useState} from 'react';
import PropTypes from 'prop-types';

// Material UI
import {makeStyles} from '@material-ui/core/styles';

// Components
import {createDefaultLayout} from './layout-presets';

// Contexts
import {LayoutContext} from '../../../contexts/layout-context';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
});

const Root = ({
  className,
  children,
  config: {
    clipped,
    collapsible,
    collapsedWidth,
    navVariant,
    navWidth,
    navAnchor,
    headerPosition,
    squeezed,
    footerShrink,
  },
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const value = {
    open,
    setOpen,
    collapsed,
    setCollapsed,
    clipped,
    collapsible,
    collapsedWidth,
    navVariant,
    navWidth,
    navAnchor,
    headerPosition,
    squeezed,
    footerShrink,
  };

  return (
    <LayoutContext.Provider value={value}>
      <div className={`${className} ${classes.root}`}>
        {typeof children === 'function' ? children(value) : children}
      </div>
    </LayoutContext.Provider>
  );
};

Root.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  className: PropTypes.string,
  config: PropTypes.shape({
    clipped: PropTypes.bool,
    collapsed: PropTypes.bool,
    collapsedWidth: PropTypes.number,
    collapsible: PropTypes.bool,
    footerShrink: PropTypes.bool,
    headerPosition: PropTypes.oneOf(['static', 'relative', 'sticky', 'fixed', 'absolute']),
    navAnchor: PropTypes.oneOf(['left', 'bottom']),
    navVariant: PropTypes.oneOf(['permanent', 'persistent', 'temporary']),
    navWidth: PropTypes.number,
    squeezed: PropTypes.bool,
  }),
};

Root.defaultProps = {
  className: '',
  config: createDefaultLayout(),
};

export default Root;
